module.exports = __webpack_public_path__ + "fonts/c99de6928538d119a8d507d0216a5682.svg";